export default __webpack_public_path__ + "static/media/Purified Daggamalt.4d05afa1.jpg";